import { defineComponent } from "vue";
export default defineComponent({
    props: {
        progress: {
            type: Number
        }
    },
    computed: {
        backgroundProgress: function () {
            return "background: linear-gradient(90deg, #0197f6 0 " + this.progress + "%, #d90429 0 100%);";
        },
        iconProgress: function () {
            return "left: " + this.progress + "%;";
        }
    }
});
